/**
 * Desktop mega menu toggle functionality
 *
 * Handles opening and closing the desktop mega menu overlay
 */
export function initDesktopMegaMenu() {
	const megaMenu = document.querySelector('.desktop-mega-menu');
	const megaMenuToggle = document.querySelector('.desktop-mega-menu-toggle');
	const megaMenuClose = document.querySelector('.desktop-mega-menu-close');

	if (!megaMenu || !megaMenuToggle || !megaMenuClose) {
		return;
	}

	// Open mega menu
	megaMenuToggle.addEventListener('click', (e) => {
		e.preventDefault();
		megaMenu.classList.remove('opacity-0', 'invisible', 'scale-[0]', 'translate-x-full', 'translate-y-[-100%]');
		megaMenu.classList.add('opacity-100', 'visible', 'scale-100', 'translate-x-0', 'translate-y-0');
		document.body.classList.add('mega-menu-open');
		// Update ARIA attributes
		megaMenuToggle.setAttribute('aria-label', 'Close menu');
		megaMenuToggle.setAttribute('aria-expanded', 'true');
		megaMenuClose.setAttribute('aria-expanded', 'true');
	});

	// Close mega menu
	megaMenuClose.addEventListener('click', (e) => {
		e.preventDefault();
		closeMegaMenu();
	});

	// Close mega menu when clicking outside
	megaMenu.addEventListener('click', (e) => {
		if (e.target === megaMenu) {
			closeMegaMenu();
		}
	});

	// Close mega menu on escape key
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && megaMenu.classList.contains('opacity-100')) {
			closeMegaMenu();
		}
	});

	function closeMegaMenu() {
		megaMenu.classList.remove('opacity-100', 'visible', 'scale-100', 'translate-x-0', 'translate-y-0');
		megaMenu.classList.add('opacity-0', 'invisible', 'scale-[0]', 'translate-x-full', 'translate-y-[-100%]');
		document.body.classList.remove('mega-menu-open');
		// Update ARIA attributes
		megaMenuToggle.setAttribute('aria-label', 'Open menu');
		megaMenuToggle.setAttribute('aria-expanded', 'false');
		megaMenuClose.setAttribute('aria-expanded', 'false');
	}
}

